import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import { usePublicProjectsApi } from '@/api/projects'
import {
  DEFAULT_PROJECT_SORT,
  type ProjectSort,
} from '@/components/Public/Projects/project-sort'
import { PublicProjectsRow } from '@/components/Public/Projects/Project/PublicProjectsRow'

/** Where a click goes: this row is embedded on the marketing site, so it has
 *  to leave the embedding origin for the app's own. */
const APP_ORIGIN = 'https://app.brick-up.com'

/** The projects row on its own, for embedding on the marketing site. */
function PublicProjectsPreview() {
  const { useFindQuery } = usePublicProjectsApi()
  const { data: projects } = useFindQuery()
  const [sort, setSort] = useState<ProjectSort>(DEFAULT_PROJECT_SORT)

  if (!projects || projects.length === 0) return null

  return (
    <div className="flex-1 bg-white p-4 md:p-6">
      <PublicProjectsRow
        projects={projects}
        showHeader
        sort={sort}
        onSortChange={setSort}
        externalBaseUrl={APP_ORIGIN}
      />
    </div>
  )
}

export const Route = createFileRoute('/public/projects-preview/')({
  component: PublicProjectsPreview,
})
